// Elitism (Jupiter): the three highest scoring constellations score more;
// with three or fewer, all of them.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { ranked } from '../shared/standings';
import type { AlignmentDef } from '../types';

export const elitism: AlignmentDef = {
  id: 'elitism',
  planet: 'jupiter',
  name: 'Elitism',
  text: () => `Your ${N.elitismCount} highest scoring constellations score +${N.elitismPercent}%.`,
  standing: (entries) => ranked(entries).slice(0, N.elitismCount).map((e) => ({ index: e.index, percent: N.elitismPercent })),
};
